import styled from 'styled-components';

export const AuthLayoutWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0a0a0f;
  background-image: 
    radial-gradient(circle at 20% 50%, rgba(120, 40, 200, 0.13) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(224, 5, 255, 0.13) 0%, transparent 50%),
    radial-gradient(circle at 40% 20%, rgba(167, 60, 255, 0.1) 0%, transparent 50%);
  color: #cccccc;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const AuthContainer = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #252526;
  padding: 40px;
  border-radius: 8px;
  border: 1px solid #3c3c3c;
`;

export const Logo = styled.img`
  width: 100px;
  margin-bottom: 20px;
`;

export const FooterText = styled.p`
  margin-top: 20px;
  color: #888;
  font-size: 12px;
`;

export const Title = styled.h1`
  color: #cccccc;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 24px;
  text-align: center;
`;
